export enum ButtonAction {
  BeginCheckIn,
  GoToSigningRoom,
  GoToWaitingRoom,
  Rejoin,
}
